import actions from './action.js';
import mutations from './mutations.js';
import getters from './getters.js';
const state = {
    routeName: '',
    fontSize: 12,
    remainTime: 0, //考试剩余时间,
    socketType: 0, //socket收到消息type(6种)
    socketData: {} //socket收到消息数据
}
export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/anscart/index.js